import { Routes, Route, Navigate } from 'react-router-dom';
import routes from './app-routes';
import { SideNavOuterToolbar as SideNavBarLayout } from './layouts';

export default function Content() {
  return (
    <SideNavBarLayout>
      <Routes>
        {routes.map(({ path, element }) => (
          <Route
            key={path}
            path={path}
            element={element}
          />
        ))}
        <Route
          path='*'
          element={<Navigate to='/infringement-alert' />} // TO MAKE THE "infringement-alert" LANDING PAGE - NIKHIL GYAN
        />
      </Routes>
      </SideNavBarLayout>
  );
}

